export const isProductGroupDraftLiveEqual = (group) => {
  let differenceKeys = []
  let buttonDifferenceKeys =[]
  let isEqual = (JSON.stringify(group.current) === JSON.stringify(group.draft))
  
  if(!group.current) return isEqual
  if(!group.current.buttonConfig) return isEqual

  Object.keys(group.draft).forEach(key => {
    if(key === 'buttonConfig') return
    if(group.draft[key] !== group.current[key]) differenceKeys.push(key)
  })

  // check the difference between current and draft button config
  // exceptions uuid, state, createdAt, updatedAt
  // if button difference is not exactly 3 or 4, then there's a difference between the two
  if(group.current.buttonConfig) {
    Object.keys(group.draft.buttonConfig).forEach(key => {
      if(group.draft.buttonConfig[key] !== group.current.buttonConfig[key]) buttonDifferenceKeys.push(key)
    })
  }

  let isButtonDraftLiveEqual = true
  if(buttonDifferenceKeys.length === 3) {
    isButtonDraftLiveEqual = (buttonDifferenceKeys.includes('uuid') && buttonDifferenceKeys.includes('state') && buttonDifferenceKeys.includes('createdAt'))
  }
  else if(buttonDifferenceKeys.length === 4) {
    isButtonDraftLiveEqual = (buttonDifferenceKeys.includes('uuid') && buttonDifferenceKeys.includes('state') && buttonDifferenceKeys.includes('createdAt') && buttonDifferenceKeys.includes('updatedAt'))
  }
  else if(buttonDifferenceKeys.length > 4) {
    isButtonDraftLiveEqual = false
  }

  return differenceKeys.length === 0 && (buttonDifferenceKeys.length === 0 || isButtonDraftLiveEqual)
}

export const isControlBarDraftLiveEqual = (controlBarConfig) => {
  if(!controlBarConfig) return
  let isEqual = (JSON.stringify(controlBarConfig.current) === JSON.stringify(controlBarConfig.draft))
  
  if(!controlBarConfig.current) return isEqual

  // check the difference between current and draft button config
  // exceptions uuid, state, createdAt, updatedAt
  // if button difference is not exactly 3 or 4, then there's a difference between the two

let mobileDifferences = []
let desktopDifferences = []
  if(controlBarConfig.current.desktop && controlBarConfig.current.mobile) {
    Object.keys(controlBarConfig.draft.desktop).forEach(key => {
      if(controlBarConfig.draft.desktop[key] !== controlBarConfig.current.desktop[key]) desktopDifferences.push(key)
    })

    Object.keys(controlBarConfig.draft.mobile).forEach(key => {
      if(controlBarConfig.draft.mobile[key] !== controlBarConfig.current.mobile[key]) mobileDifferences.push(key)
    })
  }

  desktopDifferences = desktopDifferences.filter(key => !(key === 'uuid' || key === 'state' || key === 'createdAt' || key === 'updatedAt'))
  mobileDifferences = mobileDifferences.filter(key => !(key === 'uuid' || key === 'state' || key === 'createdAt' || key === 'updatedAt'))




  return desktopDifferences.length === 0 && mobileDifferences.length === 0
}
